import React, { Component } from 'react';
import { ButtonToolbar, Panel } from 'react-bootstrap';

class ConfirmationMail extends Component {

    FormButtons = () => {
        return this.props.buttons && this.props.buttons.map((button, index) => 
            //<Button key={index} className="button-common flex-center" onClick={button.action}>{button.label}</Button>
            //<div><script language="Javascript">document.open;document.write("<a key={index} href='mailto:mail@test.com'> test </a>");document.close;</script></div>
            <a key={index} className="mailto-button flex-center" href={button.link} onClick={button.action}>{button.text}</a>
        )
    }

    render() {
        let display = this.props.showConfirmation ? 'block' : 'none';

        return (
            this.props.showConfirmation  && 
            <div className="overlay overlay-dark" style={{ display: display }}>
                <div className="flex-center">
                    <Panel className="confirmation-card">
                        <div className="confirmation-message">{this.props.message}</div>
                        <ButtonToolbar className="confirmation-buttons">
                            {this.FormButtons()}
                        </ButtonToolbar>
                    </Panel>
                </div>
            </div>
        );
    }
};

export default ConfirmationMail;

